import angular from 'angular';

const circliful = angular.module('ttb.directives.circliful', [])
    .directive('circliful', () => {
        return {
            scope: {
                percent: '<circlifulPercent',
                fgColor: '@circlifulFgColor',
                bgColor: '@circlifulBgColor',
            },
            controller: function ($scope, $element) {
                'ngInject';
                const render = () => {
                    $element.html('');

                    const container = angular.element(`<div data-percent="${$scope.percent}"
                        data-text="${$scope.percent}%"
                        data-dimension="76" data-width="4"
                        data-fontsize="11"
                        data-fgcolor="${$scope.fgColor}"
                        data-bgcolor="${$scope.bgColor}"></div>`);
                    $element.append(container);

                    container.circliful();
                };
                $scope.$watch('percent', render) ;
            }
        }
    })
    .name;

export default circliful;



// WEBPACK FOOTER //
// ../directives/circliful.js